import React from 'react';
import { factory } from '../../../../../factory/factory.utils.mjs';
import { RadioButtonCard } from '../../../../RadioButton/RadioButtonCard/RadioButtonCard.mjs';
import { useRadioGroupContext } from '../../../../RadioButton/RadioGroup.context.mjs';
import { ColorSwatch } from '../../../ColorSwatch.mjs';
import classes from '../ColorSwatchRadioGroup.module.css.mjs';

const ColorSwatchRadioButton = factory((props, ref) => {
  const { value, checked, label, disabled, ...rest } = props;
  const ctx = useRadioGroupContext();
  const _checked = typeof checked === "boolean" ? checked : ctx?.value.includes(value || "") || false;
  return /* @__PURE__ */ React.createElement(
    RadioButtonCard,
    {
      label,
      checked: _checked,
      ref,
      value,
      type: "button",
      disabled,
      "aria-disabled": disabled,
      className: disabled && classes.disabled
    },
    /* @__PURE__ */ React.createElement(ColorSwatch, { isSelected: _checked, component: "div", label, disabled, ...rest })
  );
});

export { ColorSwatchRadioButton };
